import { combineReducers } from "redux";
import dataSliceReducer from "./dataSlice";

export default combineReducers({
  dataState: dataSliceReducer,
});